import {defineStore} from 'pinia';
import {readonly, ref} from 'vue-demi';
import {Authoxuser} from "@/http/organization/models/Authoxuser";
import {principalInfoController} from "@/http/organization/PrincipalInfoController";
import {PrincipalInfoVO} from "@/http/organization/models/PrincipalInfoVO";

// export type UserInfo = {
//     id: string,
//     account: string,
//     name: string,
//     principalId?:string
// }
const USER_STORE = 'USER_STORE';

export const useUserStore = defineStore(USER_STORE, () => {
    const info = ref<Authoxuser | null>(null);
    const principalType = ref<string>('')
    const authoxType = ref<string>('')
    const setUserInfo = (data: Authoxuser) => {
        info.value = data;
        // info.value.principalId='123456'


    };

    const setPrincipalType = async (type: string) => {
        // const data: PrincipalInfoVO = await principalInfoController.getById(principalId)
        principalType.value = type || ''
        authoxType.value = principalType.value
        if (type === 'government') {
            authoxType.value = 'gov'
        } else if (type === 'production') {
            authoxType.value = 'produce'
        }
    }
    return {
        info: readonly(info),
        setUserInfo,
        setPrincipalType,
        authoxType: readonly(authoxType),
        principalType: readonly(principalType)
    };
});
